// @ts-nocheck

import { BasketStatuses } from '../../../types/basket';
import { number as numberUtils } from '../../../utils/';

/**
 * Set item freebetId as boolean to be use as freebet balance
 * @param  {Object} state        The actual state.
 * @param  {Object} action       The action to reduce.
 * @param  {Object} options.user The user's state
 * @return {Object}              Return the new state.
 */
const basketItemSetFreebetBoolean = (state, action, { user }) => {
  const { status, items } = state;
  const { oddId, freebetId } = action.payload;
  const formattedUserBalance = user?.balance / 100;
  const formattedUserFreebetBankroll = user?.freebetBankroll / 100;
  const selectedBankroll = freebetId ? formattedUserFreebetBankroll : formattedUserBalance;
  const stake = items[oddId]?.stake;
  const hasStakeAndBankroll = !!stake && !numberUtils.checkIsNaN(selectedBankroll); // use of checkIsNaN()
  // to prevent the stake to return a string like `NaN`

  if (status !== BasketStatuses.PENDING && status !== BasketStatuses.VALIDATED && status !== BasketStatuses.WAITING) {
    const item = items[oddId];

    if (item) {
      const { selectedFreebetId } = item;
      if (selectedFreebetId !== freebetId) {
        return {
          ...state,
          items: {
            ...items,
            [oddId]: {
              ...item,
              selectedFreebetId: freebetId,
              stake: hasStakeAndBankroll ? Math.min(Number(stake), selectedBankroll).toString() : stake,
              eligibleKLCollectibleId: freebetId ? null : item.eligibleKLCollectibleId,
              isGRActive: freebetId ? false : item.isGRActive,
              isMonopolyActive: freebetId ? false : item.isMonopolyActive,
              isBoomActive: freebetId ? false : item.isBoomActive,
            },
          },
        };
      }
    }
  }
  return state;
};

export default basketItemSetFreebetBoolean;
